import { render } from "./MandatoryLearn.vue?vue&type=template&id=67064166"
import script from "./MandatoryLearn.vue?vue&type=script&lang=ts"
export * from "./MandatoryLearn.vue?vue&type=script&lang=ts"

import "./MandatoryLearn.vue?vue&type=style&index=0&id=67064166&lang=css"
script.render = render

export default script